import {forwardRef} from 'react';
import {SnackbarContent, useSnackbar} from 'notistack';
import {Alert} from '@mui/material';

const brandSnackbar = (severity) => forwardRef(function BrandSnackbar({id, message}, ref) {
    const {closeSnackbar} = useSnackbar();

    return (
        <SnackbarContent ref={ref}>
            <Alert
                severity={severity}
                variant="filled"
                onClose={() => closeSnackbar(id)}
                sx={{width: '100%', minWidth: 288, maxWidth: 420, boxShadow: 3}}
            >
                {message}
            </Alert>
        </SnackbarContent>
    );
});

export const SuccessSnackbar = brandSnackbar('success');
export const ErrorSnackbar = brandSnackbar('error');
export const WarningSnackbar = brandSnackbar('warning');
export const InfoSnackbar = brandSnackbar('info');
